// The map styles object defines paths to various map styles, but with a relative path i.e.
// '/tiles/pois/...' which does not work when running the Routebuilder UI locally. By checking
// the node env we can prepend the staging url onto the mapstyle which allows it to render
// properly in all environments.
const isDevOrStaging = process.env.NODE_ENV !== 'production';
const mapPathPrefix = isDevOrStaging ? 'https://www.staging.strava.com' : '';

export default {
  standard: `${mapPathPrefix}/tiles/pois/default-poi-style.json?style=standard`,
  winter: `${mapPathPrefix}/tiles/pois/default-poi-style.json?style=winter`,
  satellite: `${mapPathPrefix}/tiles/pois/default-poi-style.json?style=satellite`,
  hybrid: `${mapPathPrefix}/tiles/pois/default-poi-style.json?style=hybrid`,
  light: `${mapPathPrefix}/tiles/pois/default-poi-style.json?style=light`,
  dark: `${mapPathPrefix}/tiles/pois/default-poi-style.json?style=dark`
};
